import { useNavigate } from 'react-router-dom';
import { Formatters } from '../../core/util/formatters';
import { PhoneNormalizer } from '../../core/util/phoneNormalizer';
import { S } from '../../i18n/strings';
import { useSession } from '../../state/SessionContext';
import { useTheme, type ThemePreference } from '../../state/ThemeContext';
import { EmptyState } from '../components/StateContainer';

const THEMES: { key: ThemePreference; label: string }[] = [
  { key: 'SYSTEM', label: S.profileThemeSystem },
  { key: 'LIGHT', label: S.profileThemeLight },
  { key: 'DARK', label: S.profileThemeDark },
];

export function ProfileScreen() {
  const navigate = useNavigate();
  const { user, logout } = useSession();
  const { preference, setPreference } = useTheme();

  return (
    <div className="stack stack--loose">
      <h1>{S.profileTitle}</h1>

      {user ? (
        <>
          <section className="section">
            <h2>{S.profilePersonal}</h2>
            <div className="profile-row">
              <span className="avatar" aria-hidden="true">
                {(user.fullName || user.email || '?').charAt(0).toUpperCase()}
              </span>
              <div className="stack stack--tight">
                {user.fullName && <strong>{user.fullName}</strong>}
                {user.email && <span className="muted">{user.email}</span>}
                {/* Sin teléfono la línea no existe, en lugar de un "—" que no informa. */}
                {user.phone && <span className="muted">{PhoneNormalizer.format(user.phone)}</span>}
              </div>
            </div>
          </section>

          {(user.favoriteCuisines.length > 0 || user.defaultPartySize) && (
            <section className="section">
              <h2>{S.profilePreferences}</h2>
              {user.favoriteCuisines.length > 0 && (
                <div className="row">
                  <span className="muted">{S.profileFavoriteCuisines}</span>
                  {user.favoriteCuisines.map((cuisine) => (
                    <span key={cuisine} className="chip chip--static">
                      {cuisine}
                    </span>
                  ))}
                </div>
              )}
              {user.defaultPartySize && (
                <p className="muted">
                  {S.profileDefaultParty}: {Formatters.partySize(user.defaultPartySize)}
                </p>
              )}
            </section>
          )}
        </>
      ) : (
        <EmptyState
          icon="👤"
          title={S.profileGuestTitle}
          body={S.profileGuestBody}
          action={{ label: S.authLogin, onClick: () => navigate('/entrar?volver=/perfil') }}
        />
      )}

      <section className="section">
        <h2>{S.profileSettings}</h2>
        <div className="row">
          <span className="muted">{S.profileTheme}</span>
          <div className="segmented">
            {THEMES.map((theme) => (
              <button
                key={theme.key}
                type="button"
                aria-pressed={preference === theme.key}
                onClick={() => setPreference(theme.key)}
              >
                {theme.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {user && (
        <button type="button" className="btn btn--outline" onClick={logout}>
          {S.profileLogout}
        </button>
      )}
    </div>
  );
}
